export const getUrlHost = (_url) => {
    try {
        const url = new URL(_url)
        return url.host;
    } catch (e) {
        return '';
    }
}